import JalaliDateCell from "./JalaliDateCell";

const FirstReportCell = ({ record }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {record?.firstReportDate ? (
        <JalaliDateCell date={record.firstReportDate} />
      ) : (
        <span dir="ltr">-</span>
      )}
    </div>
  );
};

export default FirstReportCell;
